"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _objectDestructuringEmpty2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectDestructuringEmpty"));

var _react = _interopRequireDefault(require("react"));

var _Item = _interopRequireDefault(require("./../../Item"));

var _defaultModule = _interopRequireDefault(require("./default.module.scss"));

function LastColumn(_ref) {
  (0, _objectDestructuringEmpty2["default"])(_ref);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: _defaultModule["default"]['wrapper']
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: _defaultModule["default"]['line']
  }, /*#__PURE__*/_react["default"].createElement(_Item["default"], {
    size: 'big'
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: _defaultModule["default"]['line']
  }, /*#__PURE__*/_react["default"].createElement(_Item["default"], {
    size: 'big'
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: _defaultModule["default"]['line']
  }, /*#__PURE__*/_react["default"].createElement(_Item["default"], {
    size: 'big'
  })));
}

var _default = LastColumn;
exports["default"] = _default;